// Module
var code = "<record-form-view fields=\"stateController.formFields\" model=\"stateController.progressiveMeterReadingSetting\" title=\"Add Meter Reading Setting\" on-submit=\"stateController.submit(formViewController)\" on-cancel=\"stateController.cancel()\"> </record-form-view> ";
// Exports
export default code;